(function(){
	'use strict';

  angular
    .module('app.blog')
    .config(routes);

  function routes($stateProvider) {
  	$stateProvider
  		.state('blog', {
        url: '/blog',
        templateUrl: 'moduloBlog/inicial.template.html',
        controller: 'InicialBlogController',
        controllerAs: 'vm',
        parent: 'main'
      })
      .state('blogInterna', {
        url: '/blog/:sluginterna',
        templateUrl: 'moduloBlog/interna.template.html',
        controller: 'InternaBlogController',
        controllerAs: 'vm',
        parent: 'main'
      })
  }

})();
